module.exports = __webpack_public_path__ + "img/xlcp.0e7cea5b.png";